import styled from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";
import { Spinner } from "pro-features/components/Loaders/src/Spinner";
const RIGHT_CONTAINER_WIDTH = "65%";
const ADDITIONAL_SPINNER_STYLE = `
            align-items: center;
            justify-content: center;
        `;
const FLEX_IN_A_ROW = `display: flex;
    flex-direction: row;`;
const FLEX_IN_A_COLUMN = `display: flex;
    flex-direction: column;`;
const BORDER_STYLE = `1px solid ${colorsPalettes.carbon[100]}`;

export const Wrapper = styled.div<{ wrapperWidth: string }>`
    ${FLEX_IN_A_COLUMN};
    width: ${({ wrapperWidth }) => `${wrapperWidth}`};
    height: 367px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 3px 6px 0 ${rgba(colorsPalettes.carbon[500], 0.08)};
    border-radius: 4px;
    box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
    ${FLEX_IN_A_COLUMN};
    gap: 8px;
    padding: 20px 0 8px 24px;
    border-bottom: ${BORDER_STYLE};
`;

export const TitleContainer = styled.div`
    ${FLEX_IN_A_ROW};
    align-items: center;
    gap: 8px;
`;

export const TitleStyle = styled.span`
    font-size: 20px;
    font-family: Roboto;
    color: ${colorsPalettes.carbon[500]};
    font-weight: 500;
`;

export const DurationContainer = styled.div`
    ${FLEX_IN_A_ROW};
    align-items: center;
`;

export const IconStyled = styled(SWReactIcons)`
    margin-right: 8px;
    path {
        fill: ${colorsPalettes.carbon[200]};
    }
`;

export const TextStyle = styled.span`
    ${setFontVariant("value", colorsPalettes.carbon[400])};
    margin-right: 10px;
`;

export const BodyContainer = styled.div`
    height: 235px;
    ${FLEX_IN_A_ROW};
`;

export const FooterContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    padding: 5px 16px 5px 0;
    border-top: ${BORDER_STYLE};
`;

export const LeftContainer = styled.div<{ isSpinner?: boolean }>`
    display: flex;
    border-right: 1px solid ${colorsPalettes.carbon[50]};
    width: calc(100% - ${RIGHT_CONTAINER_WIDTH});
    min-width: 160px;

    ${({ isSpinner }) => isSpinner && ADDITIONAL_SPINNER_STYLE}
`;

export const RightContainer = styled.div<{ isSpinner?: boolean }>`
    ${FLEX_IN_A_COLUMN};
    padding: 15px 25px 16px 24px;
    width: ${RIGHT_CONTAINER_WIDTH};
    ${({ isSpinner }) => isSpinner && ADDITIONAL_SPINNER_STYLE}
    min-width: 300px;
`;

export const Banner = styled.div`
    ${FLEX_IN_A_ROW};
    gap: 4.5px;
    background-color: ${colorsPalettes.sky[100]};
    padding: 6px 0 6px 8px;
    border-radius: 4px;
`;

export const BannerText = styled.span`
    ${setFontVariant("listItem3", colorsPalettes.carbon[400])};
`;

export const LightBulbStyled = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.carbon[400]};
    }
`;

export const NoDataContainer = styled.div`
    ${FLEX_IN_A_COLUMN};
    align-items: center;
    padding: 50px 0;
`;

export const NoDataTextPrimary = styled.span`
    ${setFontVariant("subTitle3", colorsPalettes.carbon[500])}
    margin-top: 16px;
`;
export const NoDataTextSecondary = styled.span`
    ${setFontVariant("listItem3", colorsPalettes.carbon[300])};
    margin-top: 8px;
`;

export const ImageStyle = styled.span`
    height: 95px;
    width: 134px;
`;

export const LoadersContainer = styled.div`
    ${FLEX_IN_A_ROW};
    height: 100%;
`;

export const RightSpinner = styled(Spinner)`
    display: flex;
    align-items: center;
    height: 45px;
    width: 45px;
`;

export const LeftSpinner = styled(RightSpinner)`
    border-right: 1px solid ${colorsPalettes.carbon[50]};
`;

export const LeftMetricContainer = styled.div`
    ${FLEX_IN_A_COLUMN};
    align-items: center;
    padding: 50px 32px 17px 32px;
    text-align: center;
`;
